module.exports = __webpack_public_path__ + "img/Nurse.ac043631.svg";